/**
 * @file   src\reducers\locations.js
 * @brief  This file is responsible for locations reducer
 * @date   April, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import { createSlice } from "@reduxjs/toolkit";
import {
  fetchGitchaAvailableCities,
  fetchAllAvailableCities,
} from "../actions/locations";
const initialState = {
  loading: false,
  availableCities: [],
  allCities: [],
  allCitiesLoaded: false,
  error: "",
};

const locations = createSlice({
  name: "locations",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchGitchaAvailableCities.pending, (state, action) => {
      state.loading = true;
      state.availableCities = state.availableCities;
      state.error = "";
    });
    builder.addCase(fetchGitchaAvailableCities.fulfilled, (state, action) => {
          state.loading = false;
          state.availableCities =  state.availableCities.concat(action.payload);
          state.error = "";
      });

    builder.addCase(fetchGitchaAvailableCities.rejected, (state, action) => {
      state.loading = false;
      state.availableCities = state.availableCities;
      state.error = action.error.message;
    });

    // Fetch all cities for search dropdown filtering
    builder.addCase(fetchAllAvailableCities.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(fetchAllAvailableCities.fulfilled, (state, action) => {
      state.loading = false;
      state.allCities = action.payload;
      state.allCitiesLoaded = true;
      state.error = "";
    });
    builder.addCase(fetchAllAvailableCities.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
  },

});

export default locations.reducer;
